import React, { useState, useEffect, useContext } from 'react';
import {format, subDays, startOfMonth} from "date-fns";

import * as net from "../../lib/net";
import Dt_Txt from "../../lib/ui/dt_txt";

//import PdfDlg from "./dlg/pdf_dlg";
//import LoginDlg from "./dlg/login_dlg";

import sso from "../../sso.js";

function web01() {

    var html =
    <div className="">
        Test
    </div>
    ;
    return html;
}

class Eko_Period extends React.Component {
    //var sdo = useContext(SDOContext); // Functional
    //static contextType = SDOContext; // Class

    constructor(props, context) {
        super(props);

        this.webStore = props.store;
        this.state = {};
        this.state.gaa = [];
        this.state.loading = 0;
        this.state.sdo = {};
        this.state.eka = [];

        this.state.tot = {};
        this.state.tot.netto = 0;
        this.state.tot.brutto = 0;
        this.state.tot.resultat = 0;

        this.state.today = new Date();
        var fdatum = startOfMonth(this.state.today);
        var fdat = format(fdatum, "yyyy-MM-dd");
        var tdat = format(this.state.today, "yyyy-MM-dd");
        this.state.fdat = fdat;
        this.state.tdat = tdat;
    }
    componentDidMount(){
        this.st_oms();
    }

    componentWillUnmount(){
    }

    row_css(row) {
        var css = {};
        if(this.state.row) {
            if(this.state.row.ank == row.ank) {
                css.background = "#080";
                css.color = "#fff";
            }
        }
        return css;
    }
    tb_style() {
        var css = {};
        //css.height = window.innerHeight - 225;
        //css.overflow = "auto";
        return css;
    }
  xst_oms() {
    var self = this;

    var prm = {};
    prm.req = "pos.pos_eko.sth_dep";
    prm.avd = this.state.avd;
    prm.fdat = this.state.fdat;
    prm.tdat = this.state.tdat;
    //alert(JSON.stringify(prm));

    net.sio_req(prm)
    .then(function(ret){
        ///alert(JSON.stringify(ret));

        var sdo = ret.rco;
        var a = [];
        var keys = Object.keys(sdo.dpo);
        for(var key of keys) {
            var o = sdo.dpo[key];
            a.push( o );
        }
        a.push( sdo.tot );
        //self.setState({dto: dto, eka: a }, () => self.line_chart());
        self.setState({sdo: sdo, eka: a });
    })
    .catch(function(e){
        var txt = JSON.stringify(e);
    });
  }
    st_oms() {
        var self = this;
    
        var sdo = {};
        sdo.eko = {};
        //var fdat = format(this.state.fdat, "yyyy-MM-dd");
        //var tdat = format(this.state.tdat, "yyyy-MM-dd");
        var fdat = this.state.fdat;
        var tdat = this.state.tdat;
    
        //var csa = self.get_csa();
        var csa = sso.sdo.csa;

        function send_req(cso) {
            const promise1 = new Promise((resolve, reject) => {
                //setTimeout(resolve, 500, 'one');
                var prm = {};
                prm.sid = cso.c0sid;
                prm.req = "pos.pos_eko.sth_oms";
                prm.avd = cso.c0avd;
                if(cso.c0dpa) prm.dpa = JSON.stringify(cso.c0dpa);
                prm.fdat = fdat;
                prm.tdat = tdat;
                //alert(JSON.stringify(prm));
    
                net.sid_req(prm)
                .then(function(ret){
                    //alert(JSON.stringify(ret));
                    //alert(JSON.stringify(ret.rco.tot));
                    //sdo.eko[sid] = ret.rco;
                    sdo.eko[cso.c0sid] = {};
                    sdo.eko[cso.c0sid].lopnr = cso.c0lopnr;
                    sdo.eko[cso.c0sid].text = cso.c0text;
                    sdo.eko[cso.c0sid].tot = ret.rco.tot;
                    resolve();
                })
                .catch(function(e){
                    var txt = JSON.stringify(e);
                });
            });
            return promise1;
        }
        var qa = [];
        for(var so of csa) {
            var promise = send_req(so);
            qa.push(promise);
        }

        Promise.all(qa)
        .then(function(ret){
            //alert(JSON.stringify(ret));
            //var eka = Object.values(sdo.eko);
            var tot = {};
            tot.netto = 0;
            tot.brutto = 0;
            tot.resultat = 0;
            var eka = [];
            var keys = Object.keys(sdo.eko);
            //alert(JSON.stringify(keys));
            keys.sort();
            for(var key of keys) {
                var o = sdo.eko[key];
                //alert(JSON.stringify(o.tot.netto));
                tot.netto = tot.netto + (o.tot.netto * 1);
                tot.brutto = tot.brutto + (o.tot.brutto * 1);
                tot.resultat = tot.resultat + (o.tot.resultat * 1);
                eka.push(o);
            }
            //alert(JSON.stringify(eka));
            self.setState({sdo: sdo, eka: eka, tot: tot });
        })
        .catch(function(e){
            var txt = JSON.stringify(e);
        });
    }
  
  dt_fdat(e) {
    //alert(JSON.stringify(e));
    var dts = format(e, "yyyy-MM-dd");
    this.setState({ fdat: dts });
  }
  dt_tdat(e) {
    //alert(JSON.stringify(e));
    var dts = format(e, "yyyy-MM-dd");
    this.setState({ tdat: dts });
  }

    render() {
/*
        var stat = [];
        var keys = Object.keys(this.state.stat);
        for (var key of keys) {
            var row = this.state.stat[key];
            stat.push(row);
        }
*/

        return (
            <div className="flex-col flex px-2">

            <div className="flex-row justify-content-between">
                <div className="">PERIODEN</div>
                 <div className="cdiblue" onClick={() => this.st_oms() }>UPPDATERA</div>
           </div>
            <div className="flex-row">
                <Dt_Txt dts={this.state.fdat} getValue={(e)=> this.dt_fdat(e) }/>
                <div className="px-2"></div>
                <Dt_Txt dts={this.state.tdat} getValue={(e)=> this.dt_tdat(e) }/>
            </div>
            <div className="divider_orange"></div>
            <div className="flex">
                <table className="table table-bordered table-hover tb fixed_header">
                    <thead>
                    <tr>
                        <th>Avdelning</th>
                        <th>Netto</th>
                        <th>Brutto</th>
                        <th>Resultat</th>
                    </tr>
                    </thead>
                    <tbody style={ this.tb_style() }>
                    { this.state.eka.map((row, key) =>
                    <tr key={key} onDoubleClick={() => this.row_open(row) } draggable={true} onDragStart={ (event) => this.drag_start(event, row)} onDrag={ (event) => this.drag(event)}>
                        <td>{ row.text.toswe() }</td>
                        <td className="text-right">{ row.tot.netto.toString().cdipris() }</td>
                        <td className="text-right">{ row.tot.brutto.toString().cdipris() }</td>
                        <td className="text-right">{ row.tot.resultat.toString().cdipris() }</td>
                    </tr>
                    )}
                    <tr >
                        <td>Summa</td>
                        <td className="text-right">{ this.state.tot.netto.toString().cdipris() }</td>
                        <td className="text-right">{ this.state.tot.brutto.toString().cdipris() }</td>
                        <td className="text-right">{ this.state.tot.resultat.toString().cdipris() }</td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div className="">
                <div className="txt_14">Totalt : { this.state.eka.length }</div>
            </div>


         </div>
        );
    }

}
//WebPub.contextType = SDOContext; // Function
export default Eko_Period;
